import { VesselParticulars } from '@navstation-portal/vessels/data-model/vessel';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { VESSEL_PARTICULARS_STORE_ID } from './constants';

export const vesselParticularsEvents = eventGroup({
  source: VESSEL_PARTICULARS_STORE_ID,
  events: {
    fetchVesselParticulars: type<string>(),
    fetchVesselParticularsSuccess: type<VesselParticulars>(),
    fetchVesselParticularsFailed: type<Error>(),
  },
});
